export const WagTagMeta = {
  title: 'Wag! Tag - Smart Dog ID Tags | Wag!',
  description: 'Wag! Tag is a smart dog ID tag for your pet — offering a comprehensive online profile and community support. Peace of mind for pet parents, 24/7.',
  robots: 'noindex, follow',
};

export const WagTagSuccessMeta = {
  title: 'Your Wag! Tag is on its way | Wag!',
  description: 'Wag! Tag is an affordable solution to smart dog ID tags to give you better pet protection. Learn about how you can get extra peace of mind for your dog, 24/7.',
  robots: 'noindex, follow',
};

export const ShelterLandingMeta = {
  title: 'Wag! Tag - Smart Dog ID Tags for your Shelter | Wag!',
  description: 'Wag! Tag is a smart dog ID tag for the pets in your shelter — offering a comprehensive online profile and community support. Peace of mind for pet parents, 24/7.',
};
